@if (show) {
  <div class="loader-overlay">
    <p-progressBar
      mode="indeterminate"
      [style]="{ height: '4px' }">
    </p-progressBar>
  </div>
}



